// auth-context.tsx
import React, { createContext, useState } from "react";
import globalConfig from "#constants/globalConfig.js";

export const AuthContext = createContext({
  isAuthenticated: false,
  login: () => {},
  logout: () => {},
  userProfile: null,
});

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem(globalConfig.TOKEN) === null || undefined
      ? false
      : true
  );

  const [userProfile, setUserProfile] = useState(null);

  const handleLogin = (token) => {
    try {
      localStorage.setItem(globalConfig.TOKEN, token);
      setIsAuthenticated(true);
    } catch (error) {
      console.error("Error setting token:", error);
    }
  };

  const handleLogout = () => {
    try {
      localStorage.removeItem(globalConfig.TOKEN);
      localStorage.removeItem(globalConfig.USER_ROLE);
      setIsAuthenticated(false);
    } catch (error) {
      console.error("Error removing token:", error);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        login: handleLogin,
        logout: handleLogout,
        userProfile: userProfile,
        setUserProfile: setUserProfile,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
